module.exports = __webpack_public_path__ + "img/camaCafe.594562d1.svg";